"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.REUSE_METRICS_ENABLED = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _session = require("@mulesoft/exchange-ui-portals-store/lib/domains/session");
var _PagesTree = _interopRequireDefault(require("../PagesTree"));
var _BackItem = _interopRequireDefault(require("./BackItem"));
/* eslint-disable react/jsx-no-useless-fragment */

var DEFAULT_PAGE_NAME = 'home';
var renderHomeFn = function renderHomeFn(_ref) {
  var homePath = _ref.homePath,
    isHomePage = _ref.isHomePage;
  return /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.SidebarItem, {
    to: homePath,
    isActive: isHomePage
  }, "Home");
};
var renderNavigationFn = function renderNavigationFn() {
  return null;
};
var renderPagesFn = function renderPagesFn(_ref2) {
  var asset = _ref2.asset,
    isDraft = _ref2.isDraft,
    isEdit = _ref2.isEdit,
    isContentLoading = _ref2.isContentLoading;
  return /*#__PURE__*/_react.default.createElement(_PagesTree.default, {
    asset: asset,
    isDraft: isDraft,
    isEdit: isEdit,
    isContentLoading: isContentLoading
  });
};
var REUSE_METRICS_ENABLED = exports.REUSE_METRICS_ENABLED = 'reuse-metrics-enabled';
var Sidebar = function Sidebar(_ref3) {
  var _assetTypesConfigurat;
  var asset = _ref3.asset,
    _ref3$isDraft = _ref3.isDraft,
    isDraft = _ref3$isDraft === void 0 ? false : _ref3$isDraft,
    _ref3$isEdit = _ref3.isEdit,
    isEdit = _ref3$isEdit === void 0 ? false : _ref3$isEdit,
    _ref3$isContentLoadin = _ref3.isContentLoading,
    isContentLoading = _ref3$isContentLoadin === void 0 ? false : _ref3$isContentLoadin,
    _ref3$isHomePage = _ref3.isHomePage,
    isHomePage = _ref3$isHomePage === void 0 ? false : _ref3$isHomePage,
    _ref3$renderHome = _ref3.renderHome,
    renderHome = _ref3$renderHome === void 0 ? renderHomeFn : _ref3$renderHome,
    _ref3$renderNavigatio = _ref3.renderNavigation,
    renderNavigation = _ref3$renderNavigatio === void 0 ? renderNavigationFn : _ref3$renderNavigatio,
    _ref3$renderPages = _ref3.renderPages,
    renderPages = _ref3$renderPages === void 0 ? renderPagesFn : _ref3$renderPages;
  var getPath = (0, _exchangeReactHooks.useGetPath)();
  var assetTypesConfiguration = (0, _exchangeReactHooks.useAssetTypesConfiguration)();
  var getPortalPath = (0, _exchangeReactHooks.useGetPortalPath)();
  var isAssetAdmin = (0, _exchangeReactHooks.useIsAssetAdmin)();
  var isMetricsEnabled = (0, _reactRedux.useSelector)(_session.selectors.isMetricsEnabled);
  var isPIRAEnabled = (0, _reactRedux.useSelector)(_session.selectors.isPIRAEnabled);
  var showMetrics = !!((_assetTypesConfigurat = assetTypesConfiguration[asset.type]) !== null && _assetTypesConfigurat !== void 0 && _assetTypesConfigurat.metrics);
  var showManagementSection = isAssetAdmin && isMetricsEnabled && showMetrics;
  var params = {
    type: asset.type,
    groupId: asset.groupId,
    assetId: asset.assetId,
    version: asset.version,
    versionGroup: asset.versionGroup,
    minorVersion: asset.minorVersion,
    pagePath: DEFAULT_PAGE_NAME
  };
  var homePath;
  if (isEdit) {
    homePath = getPath('pageEdit', params);
  } else if (isDraft) {
    homePath = getPath('pageDraft', params);
  } else {
    homePath = getPath('page', params);
  }
  return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-label": "portal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "asset-detail-links"
  }, !isPIRAEnabled ? /*#__PURE__*/_react.default.createElement(_BackItem.default, null) : null, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.SidebarTitle, null, "Pages"), /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.ErrorBoundary, null, renderHome({
    homePath: homePath,
    isHomePage: isHomePage
  }))), /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.ErrorBoundary, null, renderPages({
    asset: asset,
    isDraft: isDraft,
    isEdit: isEdit,
    isContentLoading: isContentLoading
  })), /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.ErrorBoundary, null, renderNavigation()), showManagementSection ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.SidebarTitle, null, "Management"), /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.SidebarItem, {
    to: getPortalPath('/metrics'),
    testId: "sidebar-metrics"
  }, "Asset versions engagement")) : null);
};
Sidebar.defaultProps = {
  isDraft: false,
  isEdit: false,
  isContentLoading: false,
  isHomePage: false,
  renderHome: renderHomeFn,
  renderNavigation: renderNavigationFn,
  renderPages: renderPagesFn
};
var _default = exports.default = Sidebar;
//# sourceMappingURL=Sidebar.js.map